<script>
import { navigationLinks } from "@/config/navigation.js";

export default {
  name: "Header",
  data() {
    return {
      showMenu: false,
      navLinks: navigationLinks
    };
  }
};
</script>

<template>
  <header class="block xl:fixed">
    <div class="header-main">
      <img alt="Lautstark Logopädie – Praxis für Logopädie in Troisdorf" class="logo" src="@/assets/logowebseite.png" />

      <!-- Desktop-Menü -->
      <div class="hidden xl:block">
        <template v-for="link in navLinks" :key="link.label">
          <router-link
              v-if="!link.isPhone"
              :to="link.to"
          >
            <font-awesome-icon v-if="link.icon" :icon="link.icon" />
            {{ link.label }}
          </router-link>
          <a
              v-else
              class="call"
              :href="link.to"
          >
            <font-awesome-icon v-if="link.icon" :icon="link.icon" />
            <p>{{ link.label }}</p>
          </a>
        </template>
      </div>

      <!-- Mobile-Icon -->
      <a class="xl:hidden menu-icon" @click="showMenu = !showMenu">
        <font-awesome-icon :icon="['fas', 'bars']" />
      </a>

      <!-- Mobile-Menü -->
      <div class="mobile-menu" :class="{ 'active': showMenu }">
        <font-awesome-icon
            @click="showMenu = !showMenu"
            class="close-icon"
            :icon="['fas', 'xmark']"
        />
        <div
            v-for="link in navLinks"
            :key="'mobile-' + link.label"
            class="mobile-menu--entry"
        >
          <router-link
              v-if="!link.isPhone"
              @click="showMenu = false"
              tabindex="-1"
              :to="link.to"
          >
            <font-awesome-icon v-if="link.icon" :icon="link.icon" />
            {{ link.label }}
          </router-link>
          <a
              v-else
              class="call"
              :href="link.to"
              tabindex="-1"
              @click="showMenu = false"
          >
            <font-awesome-icon v-if="link.icon" :icon="link.icon" />
            <p>{{ link.label }}</p>
          </a>
        </div>
      </div>
    </div>
  </header>
</template>

<style scoped lang="scss">
.close-icon {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: $font-size-largest;
  cursor: pointer;
}

.menu-icon {
  font-size: $font-size-largest;
}

.mobile-menu {
  background-color: $color-background;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;
  padding: $spacing-xl 0;
  transition: margin .7s;
  width: 100vw;
  margin-left: 100vw;

  &--entry {
    padding: $spacing-xl 0;
    display: block;
    border-bottom: 2px solid white;
  }
}

.active {
  margin-left: 0;
}

header {
  background: $header-background;
  color: $color-text;
  top: 0;
  left: 0;
  right: 0;
  z-index:1000;
  box-shadow: 0 7px 5px -2px rgba(0,0,0,0.6)
}

a {
  padding: 0 $spacing-s;
  margin: 0 $spacing-s;
}

.router-link-active {
  border-bottom: 2px solid $color-primary;
}

.call {
  border-radius: 0 40px 40px 40px;
  background-color: $color-primary;
  font-family: $font-family-buttons;
  box-shadow: inset 0 4px 10px -5px rgba(0, 0, 0, 0.6);
  color: white !important;
  padding: $spacing-s;
  font-weight: bold !important;

  p {
    display: inline-block;
    padding-left: $spacing-s;
    color: white;
    margin: 0 !important;
  }
}

.header-main {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: $spacing-l;

  .logo {
    height: 60px;
    margin-right: $spacing-xl;
  }
}
</style>